var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b(
        {
          staticClass: "picture-container",
          style: {
            paddingTop: _vm.height,
            width: _vm.width,
            margin: _vm.margin,
          },
        },
        "div",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("div", {
        staticClass: "picture",
        style: {
          backgroundImage: "url(" + _vm.src + ")",
          backgroundSize: "" + (_vm.size ? _vm.size : "cover"),
          padding: _vm.padding,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }